import { ReactNode } from 'react';
import { Stack, Typography } from '@optimus-web/core';

export interface HighlightScoreProps {
    value: ReactNode;
    prefix?: ReactNode;
    suffix?: ReactNode;
}

export const HighlightScore = ({ value, prefix, suffix }: HighlightScoreProps) => (
    <Stack spacing="50" data-test-highlight-score>
        {prefix ? (
            <Typography textStyle="highlightMedium" variant="tertiary" as="div">
                {prefix}
            </Typography>
        ) : null}
        <Typography textStyle="highlightMedium" data-test-value as="div">
            {value}
        </Typography>
        {suffix ? (
            <Typography textStyle="highlightMedium" variant="tertiary" as="div">
                {suffix}
            </Typography>
        ) : null}
    </Stack>
);
